import { memoize } from "lodash-es";

import { StoreContainer } from "./cache.model";

export function createStoreContainer<T>(key: string, value: T, created: number, expires: number): StoreContainer<T> {
	return {
		key,
		value,
		created,
		expires,
	};
}

export const isLocalStorageSupported = memoize(() => {
	try {
		const testKey = "testIsLocalStorageSupported";
		localStorage.setItem(testKey, "1");
		localStorage.removeItem(testKey);
		return true;
	} catch {
		return false;
	}
});
